module.exports = __webpack_public_path__ + "static/media/ProximaNova-Regular.bf9f5d50.otf";


/*****************
 ** WEBPACK FOOTER
 ** ./public/fonts/ProximaNova-Regular.otf
 ** module id = 891
 ** module chunks = 44
 **/